<template>
  <p class="control has-icons-left search">
    <b-autocomplete
      v-model="query"
      placeholder="相関索引で検索"
      :clear-on-select="clearOnSelect"
      :data="indices"
      field="literalForm"
      @select="option => move(option)">
      <template slot-scope="props">
        <div>
          <span v-html="emph(props.option.literalForm)"></span>
          → <strong>{{ notation(props.option.id) }}</strong>（{{ props.option.label }}）
        </div>
      </template>
    </b-autocomplete>
    <span class="icon is-left">
      <font-awesome-icon icon="search" />
    </span>
  </p>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify';
import { listIndexs } from '../graphql/queries';
import { notation } from '../utils';

export default {
  name: 'Search',
  data() {
    return {
      query: '',
      indices: [],
      clearOnSelect: true,
    };
  },
  methods: {
    notation,
    emph(txt) {
      return txt.replace(this.query, `<strong>${this.query}</strong>`);
    },
    move(index) {
      if (index) {
        this.$router.push({ path: `/${index.id}` });
      }
    },
  },
  watch: {
    async query() {
      if (this.query.length > 0) {
        let indices = null;
        if (this.query.length === 1) {
          indices = await API.graphql(graphqlOperation(listIndexs, {
            primary: this.query[0],
            limit: 100,
          }));
        } else {
          indices = await API.graphql(graphqlOperation(listIndexs, {
            primary: this.query[0],
            secondary: { beginsWith: this.query.slice(1) },
            limit: 100,
          }));
        }
        indices = indices.data.listIndexs.items;
        this.indices = indices;
      } else {
        this.indices = [];
      }
    },
  },
};
</script>

<style scoped>
.search {
  margin: 1rem 2rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Search.vue